$(document).ready(function () {

  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      if (entry.contentRect) {
        $('#MainContent').css('padding-top', entry.contentRect.height);
      }
    }
  });

  resizeObserver.observe($('#fixed')[0]);

  const handleScroll = function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 1) $('body').addClass('ud-scrolled');
    if (scroll < 1) $('body').removeClass('ud-scrolled');
    if (scroll > 320) $('body').addClass('ud-subnav-open');
    if (scroll <= 320) $('body').removeClass('ud-subnav-open');
  };
  handleScroll();
  $(window).scroll($.throttle(250, handleScroll));

  // Init Carousel
  $('.carousel').carousel({ keyboard: true, pause: 'hover' });

  if (window.location.href == "https://firstsaturdaylime.com/pages/faq#usage") {
    $('.usageButton').click()
  }

  /* ================ MODULES ================ */
  window.udundi = window.udundi || {};

  udundi.initCache = function () {
    udundi.cache = {
      // General
      $html: $('html'),
      $body: $('body'),

      // Customer Pages
      $recoverPasswordLink: $('#recoverPassword'),
      $hideRecoverPasswordLink: $('#hideRecoverPassword'),
      $recoverPasswordForm: $('#recoverPasswordForm'),
      $customerLoginForm: $('#customerLoginForm'),
      $passwordResetSuccess: $('#resetSuccess')
    };
  };

  udundi.init = function () {
    udundi.initCache();
    udundi.loginForms();
  };

  udundi.getHash = function () {
    return window.location.hash;
  };

  udundi.loginForms = function () {
    function showRecoverPasswordForm() {
      udundi.cache.$recoverPasswordForm.show();
      udundi.cache.$customerLoginForm.hide();
    }

    function hideRecoverPasswordForm() {
      udundi.cache.$recoverPasswordForm.hide();
      udundi.cache.$customerLoginForm.show();
    }

    udundi.cache.$recoverPasswordLink.on('click', function (e) {
      e.preventDefault();
      showRecoverPasswordForm();
    });

    udundi.cache.$hideRecoverPasswordLink.on('click', function (e) {
      e.preventDefault();
      hideRecoverPasswordForm();
    });

    // Allow deep linking to recover password form
    if (udundi.getHash() == '#recover') {
      showRecoverPasswordForm();
    }
  };

  udundi.resetPasswordSuccess = function () {
    udundi.cache.$passwordResetSuccess.show();
  };

  // Initialize Udundi's JS on docready
  $(udundi.init);


  // set first set of provinces
  updateProvinces()

  // update provinces on country change
  $('#AddressCountryNew').change(function () {
    updateProvinces()
  })

});

function updateProvinces() {
  $('#AddressProvinceNew').empty();
  const provinces = $("#AddressCountryNew option:selected").data("provinces")
  $.each(provinces, (i) => {
    $('#AddressProvinceNew')
      .append($("<option></option>")
        .attr("value", provinces[i][0])
        .text(provinces[i][0]));
  });
}

function updateProvincesCurernt(id) {
  console.log(id)
  $(`#AddressProvince_${id}`).empty();
  const provinces = $(`#AddressCountry_${id} option:selected`).data("provinces")
  $.each(provinces, (i) => {
    $(`#AddressProvince_${id}`)
      .append($("<option></option>")
        .attr("value", provinces[i][0])
        .text(provinces[i][0]));
  });
}
